import { render, staticRenderFns } from "./mapType.vue?vue&type=template&id=20e54bf6&scoped=true"
import script from "./mapType.vue?vue&type=script&lang=js"
export * from "./mapType.vue?vue&type=script&lang=js"
import style0 from "./mapType.vue?vue&type=style&index=0&id=20e54bf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e54bf6",
  null
  
)

export default component.exports